import React from 'react';
import PaymentsListFunctional from './components/payments-list-functional';

const PaymentsList = () => {
	return <PaymentsListFunctional />;
};

export default PaymentsList;
